import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: Announcement[] = [
  {
    NewFeatureID: 0,
    CreatedAtUTC: '',
    NewFeatureName: '',
    NewFeatureTitle: '',
    NewFeatureLabel: '',
    NewFeatureDescription: '',
    Hidden: false,
    ImageUrl: '',
    NewFeatureButtonLink: '',
    NewFeatureButtonLabel: '',
    ImageID: '',
    NewFeatureImageID: null,
    selectedLanguage: '',
    selectedLanguageName: '',
    defaultLanguage: {
      NewFeatureID: null,
      NewFeatureLabel: null,
      NewFeatureTitle: null,
      NewFeatureDescription: null,
      NewFeatureButtonLabel: null
    },
    translations: {
      NewFeatureID: null,
      NewFeatureLabel: null,
      NewFeatureTitle: null,
      NewFeatureDescription: null,
      NewFeatureButtonLabel: null,
      LanguageCode: null
    }
  }
]

export const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    setAnnouncementDetail: (state, action: PayloadAction<Announcement[]>) => {
      return action.payload
    },
    setAnnouncementSelectedTranslations: (
      state,
      action: PayloadAction<SetAnnouncementTranslationParms>
    ) => {
      return state.map((item) => {
        if (
          item.NewFeatureID.toString() ===
          action.payload.NewFeatureID.toString()
        ) {
          return {
            ...item,
            selectedLanguage: action.payload.selectedLanguage,
            selectedLanguageName: action.payload.selectedLanguageName,
            defaultLanguage: action.payload.defaultLanguage,
            translations: action.payload.translations
          }
        }
        return item
      })
    }
  }
})

export const { setAnnouncementDetail, setAnnouncementSelectedTranslations } =
  announcementSlice.actions
export const announcementReducer = announcementSlice.reducer
